import React from 'react'
import type { ComponentProps, MacroComponentData } from '@enonic/react-components'
import ZohoJobListingPrototype from './prototype/ZohoJobListing'

type ZohoJobListingMacroData = {
	site?: string
}

export const ZohoJobListingMacro = ({ data }: ComponentProps<MacroComponentData>) => {
	const { site } = (data || {}) as ZohoJobListingMacroData

	return <ZohoJobListingPrototype site={site} />
}
